@if (paymentType() === PaymentsMods.BILL_ME_LATER) {
  <p>{{ 'orderConfirmation.billMeLater' | cxTranslate }}</p>
}

@if ([PaymentsMods.ECHECK, PaymentsMods.CREDIT_CARD].includes(paymentType())) {
  <div class="mt-3 mb-4">
    @if (paymentType() === PaymentsMods.ECHECK) {
      <span>{{ 'orderConfirmation.eCheckPayment' | cxTranslate }} </span>
    } @else {
      <span>{{ paymentInfo().accountHolderName }} </span>
    }
    <span>{{ InvoiceUtils.getCardNumber(paymentInfo().cardNumber) }}</span>
    @if (paymentInfo().defaultPayment) {
      <span> {{'orderConfirmation.defaultPyment' | cxTranslate}}</span>
    }
  </div>
}
<p class="text-fixed-medium">
  {{['addToCartItems.paymentNote', 'addToCartItems.paymentNoteDefault'] | cxTranslate: { context: paymentType()?.toLowerCase() } }}
</p>
